<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="details_wrap container">
        <div class="details_top">
          <div class="title">
            {{ langSet == "cn" ? details.title : details.en_title }}
          </div>
          <div class="time">{{ details.create_time }}</div>
        </div>
        <div
          class="content"
          v-html="langSet == 'cn' ? details.content : details.en_content"
        ></div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import topPiece from "@/components/topPiece.vue";
import { articleDetail } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: "2025世界口腔医学大会-展览会",
      meta: [
        {
          name: "description",
          content: "2025世界口腔医学大会-展览会",
        },
        {
          name: "keywords",
          content: "2025世界口腔医学大会-展览会",
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    topPiece,
  },
  data() {
    return {
      langSet: "",
      id: "",
      details: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.id = this.$route.query.id;
    //25.6.10 获取新闻资讯 dxm
    this.getDetails(this.id);
  },
  methods: {
    async getDetails(id) {
      let data = {
        id,
      };
      const res = await articleDetail(data);
      this.details = res.data;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.details_wrap {
  .details_top {
    color: #555;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #004190;
    .title {
      color: #000;
      font-size: 30px;
      font-weight: bold;
      line-height: 61px;
    }
  }
  .content {
    padding: 30px 30px 100px;
  }
}
@media only screen and (max-width: 767px) {
  .details_wrap {
    .details_top {
      color: #555;
      font-size: 0.2rem;
      line-height: 28px;
      padding-bottom: 0.2rem;
      .title {
        font-size: 0.3rem;
        line-height: 0.6rem;
      }
    }
    .content {
      padding: 0.3rem 0.3rem 1rem;
    }
  }
}
</style>